import { useCallback, useState } from "react";
import AccountMpProvider from "@/core/data-provider/data-mp/account/account-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setEnableTfa } from "@/domains/auth/slice";

const useSignInPassword = () => {
  const tError = useErrorTranslation();
  const [loginIsPending, setLoginIsPending] = useState(false);
  const [loginError, setLoginError] = useState<string>("");
  const [loginIsCompleted, setLoginIsCompleted] = useState(false);
  const dispatch = useAppDispatch();

  const login = useCallback(
    async (password: string) => {
      try {
        if (loginIsPending) return;
        setLoginIsPending(true);
        setLoginError("");

        const response = await AccountMpProvider.login(password);

        if (response instanceof RpcMpProviderSuccessResponse) {
          setLoginIsCompleted(true);
          dispatch(setEnableTfa(response.data));
        } else {
          setLoginError(tError(response.message));
        }
      } catch ({ message }) {
        setLoginError(tError(message));
      } finally {
        setLoginIsPending(false);
      }
    },
    [loginIsPending, dispatch],
  );

  return {
    loginIsPending,
    loginError,
    login,
    loginIsCompleted,
    setLoginIsCompleted,
  };
};

export default useSignInPassword;
